module.exports = __webpack_public_path__ + "static/media/Background-Footer.cd37480b.png";